import { tva } from "@gluestack-ui/utils/nativewind-utils";

export const iconStyle = tva({
  base: "text-typography-950 fill-none pointer-events-none",
  variants: {
    size: {
      "2xs": "h-3 w-3",
      xs: "h-3.5 w-3.5",
      sm: "h-4 w-4",
      md: "h-[18px] w-[18px]",
      lg: "h-5 w-5",
      xl: "h-6 w-6",
      "2xl": "h-8 w-8",
      "3xl": "h-10 w-10",
    },
    action: {
      faint: "text-typography-300",
      muted: "text-typography-500",
      primary: "text-typography-950",
      secondary: "text-typography-700",
      tertiary: "text-typography-600",
      brand: "text-brand-500",
      success: "text-success-800",
    },
    hidden: {
      true: "hidden",
      false: "",
    },
  },
});
